module.exports = global["jQuery"] = require("-!/Users/macbookpro1/Documents/Projects/Pollini/ecommerce-slim/node_modules/expose-loader/index.js?$!./jquery.js");